"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M8.578 20.354c.391.39.861.586 1.41.586.55 0 1.02-.195 1.411-.587.391-.39.587-.86.587-1.41 0-.55-.196-1.02-.587-1.41a1.923 1.923 0 0 0-1.41-.587c-.55 0-1.02.195-1.41.586a1.923 1.923 0 0 0-.588 1.411c0 .55.196 1.02.587 1.41Zm5.992 0c.39.39.86.586 1.41.586.55 0 1.02-.195 1.41-.587.392-.39.587-.86.587-1.41 0-.55-.195-1.02-.586-1.41a1.923 1.923 0 0 0-1.41-.587c-.55 0-1.02.195-1.411.586a1.923 1.923 0 0 0-.587 1.411c0 .55.195 1.02.587 1.41Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M2.999 3.06a.999.999 0 0 0 0 1.997h1.09L5.78 9.022l2.323 6.482c.165.35.517.572.903.572h8.226a.999.999 0 0 0 .88-.525l3.767-9.038A.999.999 0 0 0 21 5.04H6.3l-.414-.854A1.997 1.997 0 0 0 4.088 3.06h-1.09Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};